import type { BattleEvent, BattleEventType } from "../../../../shared/types/BattleEvent";
import type { LaneNumber } from "../../../../shared/types/CommanderDecision";

export class BattleEventLogger {
  private readonly events: BattleEvent[] = [];
  private recentCursor = 0;

  log(type: BattleEventType, time: number, payload: Record<string, unknown> = {}, lane?: LaneNumber) {
    this.events.push({
      id: `ev_${crypto.randomUUID()}`,
      type,
      time,
      lane,
      payload
    });
  }

  drainRecent(limit = 40) {
    const nextCursor = Math.min(this.events.length, this.recentCursor + limit);
    const recent = this.events.slice(this.recentCursor, nextCursor);
    this.recentCursor = nextCursor;
    return recent;
  }

  snapshot() {
    return [...this.events];
  }

  countByType(type: BattleEventType) {
    return this.events.filter((event) => event.type === type).length;
  }
}
